import { render, staticRenderFns } from "./newCity.vue?vue&type=template&id=55c132ff&scoped=true&"
import script from "./newCity.vue?vue&type=script&lang=js&"
export * from "./newCity.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./newCity.vue?vue&type=style&index=1&id=55c132ff&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c132ff",
  null
  
)

export default component.exports